var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.5,
    height: 383,
    viewBox: "0 0 191.5 383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_463",
    "data-name": "Elipse 463",
    d: "M191.5,253A61.57,61.57,0,0,0,253,191.5c0-33.063-28.519-59.987-61.5-61.328M191.5,0C297.263,0,383,85.737,383,191.5S297.263,383,191.5,383Z",
    transform: "translate(-191.5)",
    fill: "#3acce1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipse);
export default __webpack_public_path__ + "static/media/elipse.50b1cd3bfed902924f73f892893ee94f.svg";
export { ForwardRef as ReactComponent };